import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: function() {
        return "api/activity/index.php";
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/models/useractivityModel.js
// module id = 178
// module chunks = 0